// src/App.js
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import CreateFormPage from './pages/CreateFormPage';
import FillFormPage from './pages/FillFormPage';
import ViewResponsePage from './pages/ViewResponsePage';
import HomePage from './pages/HomePage';
import EditFormPage from './pages/EditFormPage'; // Import EditFormPage
import FormEditor from './components/FormEditor'; // Import FormEditor

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/create-form" element={<CreateFormPage />} />
        <Route path="/edit-form" element={<EditFormPage />} />
        <Route path="/edit-form/:id" element={<FormEditor />} /> {/* New Route for FormEditor */}
        <Route path="/p/:id" element={<FillFormPage />} />
        <Route path="/responses/:formId/:responseId" element={<ViewResponsePage />} />
        <Route path="/" element={<HomePage />} />
      </Routes>
    </Router>
  );
}

export default App;
